import { addPvNew } from '../../../../../utils';
export default {
  props: {
    cardData: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    themeClass() {
      return (this.index + 1) % 6;
    }
  },
  mounted() {
    this.$nextTick(() => {
      const {
        cardItemDv
      } = this.$refs;
      cardItemDv && this.$io.observe(cardItemDv, () => {
        addPvNew(['POIsheet2_bdzn_xiechengznzsingle.show'], {
          title: this.cardData.headline,
          pos: this.index + 1
        });
      });
    });
  }
};